


































































import Component, { mixins } from 'vue-class-component';

import UrlMixin from '@/mixins/url';
import MenuLink from '@/components/Atoms/Link/HeaderMenuLink.vue';

@Component({
  components: {
    MenuLink,
  },
})
export default class MegaMenu extends mixins(UrlMixin) {}
